export const CONNECTED = 'CONNECTION/CONNECTED';
export const DISCONNECTED = 'CONNECTION/DISCONNECTED';
